/**
 * Common Reducers
 */
 import {
    COMMON_ACTION,
    ALL_STUDENT,
    ALL_ADMINMEMBERS,
    ALL_ACADEMYADMINLIST,
    ALL_GOLFCOACHMEMBERS,
    ALL_ACADEMYGOLFCOACH,
    ALL_SSCOACHMEMBERS,
    ALL_ACADEMYSSCOACH,
    ALL_PSYCHOLOGISTMEMBERS,
    ALL_ACADEMYPSYCHOLOGIST,
    ALL_NUTRITIONISTMEMBERS,
    ALL_ACADEMYNUTRITIONIST,
    ALL_ACADEMYSTUDENT,
    ALL_CLUB,
    ALL_PUTTINGEVALUATION,
    STUDENT_FULLDETAILS,
    ALL_MENU_LIST,
    PARENT_FULLDETAILS,
    CONTRACT_ALL_COUNT,
} from 'Actions/types';

/**
 * initial auth user
 */
const INIT_STATE = {
    studentlists:[],
    loading: false,
    adminlists:[],
    academyadminlists:[],
    golfcoachlists:[],
    academygolfcoachlists:[],
    sscoachlists:[],
    academysscoachlists:[],
    psychologistlists:[],
    academypsychologistlists:[],
    nutritionistlists:[],
    academynutritionistlists:[],
    academystudentslist:[],
    clublist:[],
    puttingevaluationlist:[],
    studentfulldetails:[],
    menulist:[],
    parentfulldetails:[],
    contractdashboardcount:[],
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        
        case COMMON_ACTION:
            return { ...state, loading: true };

        case ALL_STUDENT:
            return { ...state, loading: false, studentlists: action.payload }; 
        
        case ALL_ADMINMEMBERS:
            return { ...state, loading: false, adminlists: action.payload }; 
            
        case ALL_ACADEMYADMINLIST:
            return { ...state, loading: false, academyadminlists: action.payload }; 
        
        case ALL_GOLFCOACHMEMBERS:
            return { ...state, loading: false, golfcoachlists: action.payload }; 
            
        case ALL_ACADEMYGOLFCOACH:
            return { ...state, loading: false, academygolfcoachlists: action.payload };     
        
        case ALL_SSCOACHMEMBERS:
            return { ...state, loading: false, sscoachlists: action.payload }; 
            
        case ALL_ACADEMYSSCOACH:
            return { ...state, loading: false, academysscoachlists: action.payload }; 
        
        case ALL_PSYCHOLOGISTMEMBERS:
            return { ...state, loading: false, psychologistlists: action.payload }; 
            
        case ALL_ACADEMYPSYCHOLOGIST:
            return { ...state, loading: false, academypsychologistlists: action.payload };     
        
        case ALL_NUTRITIONISTMEMBERS:
            return { ...state, loading: false, nutritionistlists: action.payload }; 
            
        case ALL_ACADEMYNUTRITIONIST:
            return { ...state, loading: false, academynutritionistlists: action.payload }; 
            
        case ALL_ACADEMYSTUDENT:
            return { ...state, loading: false, academystudentslist: action.payload }; 
            
        case ALL_CLUB:
            return { ...state, loading: false, clublist: action.payload }; 

        case ALL_PUTTINGEVALUATION:
            return { ...state, loading: false, puttingevaluationlist: action.payload }; 
            
        case STUDENT_FULLDETAILS:
            return { ...state, loading: false, studentfulldetails: action.payload }; 

        case ALL_MENU_LIST:
            return { ...state, loading: false, menulist: action.payload }; 

        case PARENT_FULLDETAILS:
            return { ...state, loading: false, parentfulldetails: action.payload }; 

        case CONTRACT_ALL_COUNT:
            return { ...state, loading: false, contractdashboardcount: action.payload }; 

        default: return { ...state };
    }
}